/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityTrackerResourceDetailedTimeWorked } from './';
import {
    ActivityTrackerResourceDetailedTimeWorkedFromJSON,
    ActivityTrackerResourceDetailedTimeWorkedFromJSONTyped,
    ActivityTrackerResourceDetailedTimeWorkedToJSON,
} from './';
import type { WorkedUnit } from './';
import {
    WorkedUnitFromJSON,
    WorkedUnitFromJSONTyped,
    WorkedUnitToJSON,
} from './';

/**
 * 
 * @export
 * @interface ActivityTrackerResource
 */
export interface ActivityTrackerResource {
    /**
     * 
     * @type {string}
     * @memberof ActivityTrackerResource
     */
    activityType: ActivityTrackerResourceActivityTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ActivityTrackerResource
     */
    startDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ActivityTrackerResource
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityTrackerResource
     */
    lotId: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityTrackerResource
     */
    totalTimeWorked: number;
    /**
     * Free text informed by the freelancer to explain the work did for that activity report
     * @type {string}
     * @memberof ActivityTrackerResource
     */
    workDescription?: string;
    /**
     * 
     * @type {WorkedUnit}
     * @memberof ActivityTrackerResource
     */
    workedUnit: WorkedUnit;
    /**
     * 
     * @type {ActivityTrackerResourceDetailedTimeWorked}
     * @memberof ActivityTrackerResource
     */
    detailedTimeWorked?: ActivityTrackerResourceDetailedTimeWorked;
}


/**
 * @export
 */
export const ActivityTrackerResourceActivityTypeEnum = {
    Simple: 'SIMPLE',
    Detailed: 'DETAILED'
} as const;
export type ActivityTrackerResourceActivityTypeEnum = typeof ActivityTrackerResourceActivityTypeEnum[keyof typeof ActivityTrackerResourceActivityTypeEnum];


/**
 * Check if a given object implements the ActivityTrackerResource interface.
 */
export function instanceOfActivityTrackerResource(value: object): value is ActivityTrackerResource {
    if (!('activityType' in value) || value['activityType'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('lotId' in value) || value['lotId'] === undefined) return false;
    if (!('totalTimeWorked' in value) || value['totalTimeWorked'] === undefined) return false;
    if (!('workedUnit' in value) || value['workedUnit'] === undefined) return false;
    return true;
}

export function ActivityTrackerResourceFromJSON(json: any): ActivityTrackerResource {
    return ActivityTrackerResourceFromJSONTyped(json, false);
}

export function ActivityTrackerResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityTrackerResource {
    if (json == null) {
        return json;
    }
    return {
        
        'activityType': json['activityType'],
        'startDate': (new Date(json['startDate'])),
        'projectId': json['projectId'],
        'lotId': json['lotId'],
        'totalTimeWorked': json['totalTimeWorked'],
        'workDescription': json['workDescription'] == null ? undefined : json['workDescription'],
        'workedUnit': WorkedUnitFromJSON(json['workedUnit']),
        'detailedTimeWorked': json['detailedTimeWorked'] == null ? undefined : ActivityTrackerResourceDetailedTimeWorkedFromJSON(json['detailedTimeWorked']),
    };
}

export function ActivityTrackerResourceToJSON(value?: ActivityTrackerResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'activityType': value['activityType'],
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'projectId': value['projectId'],
        'lotId': value['lotId'],
        'totalTimeWorked': value['totalTimeWorked'],
        'workDescription': value['workDescription'],
        'workedUnit': WorkedUnitToJSON(value['workedUnit']),
        'detailedTimeWorked': ActivityTrackerResourceDetailedTimeWorkedToJSON(value['detailedTimeWorked']),
    };
}

